import { object, string } from "yup"

export const loginSchema = object({
  email: string("")
    .required("Email is required"),
  password: string("")
    .required("Password is required"),
})

export const registerSchema = object({
  firstName: string("")
    .required("FirstName is required"),
  lastName: string("")
    .required("LastName is required"),
  email: string("")
    .required("Email is required"),
  password: string("")
    .min(6, "PASSWORD_MIN_LENGTH")
    .required("PASSWORD_REQUIRED")
})

export const forgotPasswordSchema = object({
  email: string("")
    .required("Email is required"),
})
